<template>
<v-container fill-height>
  <v-row no-gutters>
    <v-col v-if="visible">
      <v-row no-gutters justify="center" v-if="!user">
        <v-col cols="auto" align="center">
          <v-avatar :size="64" tile class="mx-2 my-2">
            <img src="@/assets/logo.svg" />
          </v-avatar>
          <div class="subheading font-weight-bold">{{ $t('app_name') }}</div>
          <div class="pa-5 text-center" style="max-width:400px" v-html="$t('authorize.sign_in_declaration',{client:clientName})"></div>
          <v-btn color="primary" @click="login" :loading="logging">{{ $t('login') }}</v-btn>
        </v-col>
      </v-row>
      <v-row no-gutters justify="center" v-else>
        <v-col cols="auto" align="center">
          <v-row justify="center">
            <v-avatar :size="64" tile class="mx-2 my-2">
              <img src="@/assets/logo.svg" />
            </v-avatar>
            <v-icon size="32" color="primary">mdi-link</v-icon>
            <v-avatar :size="64" class="mx-2 my-2">
              <img :src="user.photoURL" />
            </v-avatar>
            <v-icon size="32" color="primary">mdi-link</v-icon>
            <v-avatar :size="64" tile class="mx-2 my-2">
              <img src="@/assets/google-assistant.svg" v-if="clientId == 'actions-smarthome'" />
              <img src="@/assets/amazon-alexa.svg" v-if="clientId == 'alexa-smarthome'" />
            </v-avatar>
          </v-row>
          <div class="mx-2 title black--text text-truncate">{{ user.displayName }}</div>
          <div class="mx-2 mb-2subtitle-2 text-truncate">{{ user.email }}</div>
          <div class="pa-5 text-center" style="max-width:400px" v-html="$t('authorize.link_user_declaration',{client:clientName,user:user.displayName})"></div>
          <v-row no-gutters justify="center">
            <v-btn class="mx-4" color="primary" @click="activate" :loading="activating">{{ $t('authorize.link') }}</v-btn>
            <v-btn text color="secondary" @click="login" :disabled="activating">{{ $t('authorize.not_me') }}</v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
  <v-footer app>
    <v-row no-gutters justify="center">
      <v-btn text small color="secondary" to="/privacy" class="mx-2">{{ $t('privacy_policy') }}</v-btn>
      <v-btn text small color="secondary" to="/terms" class="mx-2">{{ $t('terms_of_service') }}</v-btn>
    </v-row>
  </v-footer>
</v-container>
</template>

<script>
export default {
  name: 'Authorize',
  data() {
    return {
      visible: false,
      logging: false,
      activating: false,
      clients: {
        'actions-smarthome': 'Google',
        'alexa-smarthome': 'Alexa'
      },
      user: null
    }
  },
  computed: {
    clientId() {
      return this.$route.query.client_id;
    },
    clientName() {
      return this.clients[this.clientId] || '';
    }
  },
  methods: {
    login() {
      this.logging = true;
      this.$auth.signOut();
      this.$router.replace('/login?redirect=' + encodeURIComponent(this.$route.fullPath));
    },
    redirect(authCode) {
      let q = this.$route.query;
      let href = `${decodeURIComponent(q.redirect_uri)}?state=${q.state}&code=${authCode}`;
      window.location.href = href;
    },
    async activate() {
      this.activating = true;
      try {
        let q = this.$route.query;
        let host = process.env.VUE_APP_API_HOST;
        let token = await this.user.getIdToken();
        let url = `${host}/authorize`;
        let payload = `client_id=${q.client_id}&redirect_uri=${q.redirect_uri}`;
        let config = {
          headers: {
            Authorization: token
          }
        }
        await this.$http.options(url);
        let resp = await this.$http.post(url, payload, config);
        let authCode = ((resp || {}).data || {}).code;
        this.redirect(authCode);
      } catch (err) {
        this.activating = false;
        console.log('ERR', err);
      } finally {
        this.$emit('progress', false);
      }
    }
  },
  mounted() {
    this.$emit('progress', true);
    let unsubscribe = this.$auth.onAuthStateChanged(user => {
      unsubscribe();
      this.user = user;
      this.$emit('progress', false);
      this.visible = true;
    });
  }
}
</script>
